( function () {
	'use strict';

	var config = {
		'operatorGroup'      : 2,
		'filterPattern'      : /\,/g,
		'replacementPattern' : ';,;',
		'operatorKey'        : ','
	};

	function run ( math ) {
		math.register( 'commaOperator', config );
	}

	angular
		.module( 'app.components' )
		.value( 'commaOperatorConfig', config )
		.run( run );

	run.$inject = [ 'mathOperatorService' ];
} )();
